var watchlistPositionAdd = {
	title: "Ajouter position",
	subtitle: "Liste: {value}",
	noSelectedPositions: "Actuellement, il n'y a aucune position sélectionnée à ajouter à la liste.",
	singleSelectedPosition: "Il y a 1 position sélectionnée à ajouter à la liste.",
	multipleSelectedPositions: "Il y a {value} positions sélectionnées à ajouter à la liste.",
	submit: "Ok",
	cancel: "Annuler",
	remove: "Supprimer",
	validationErrors: {
		positionExists: "Votre sélection est déjà dans la liste."
	},
	noWatchlists: {
		title: "Info",
		message: "Aucune liste n'a encore été créée."
	}
};
var fr = {
	watchlistPositionAdd: watchlistPositionAdd
};

export { fr as default, watchlistPositionAdd };
